module.exports = __webpack_public_path__ + "img/carbon2.7c26900d.png";